export const container = ({ theme: { colors } }) => ({
    color: colors.white,
});

export const link = ({ theme: { colors } }) => ({
    fontSize: '1.075rem',
    lineHeight: '1.5rem',
    color: colors.cyan,
    fontWeight: 700,
    textDecoration: 'none',
    borderBottom: `0.125rem solid ${colors.blue}`,
    paddingBottom: '0.0625rem',
    transition: 'ease-out 0.2s color',
    willChange: 'color',
    marginLeft: '0.25rem',

    ':hover': {
        color: colors.fuchsia,
        cursor: 'pointer',
    },
});

export const extendText = {
    text: ({ theme: { colors } }) => ({
        color: colors.white,
        fontSize: '0.875rem',
        lineHeight: 1.8,
        fontWeight: 400,
        letterSpacing: '0.0625rem',
        tablet: {
            textAlign: 'right',
        },
    }),
};

export const extendContainer = {
    container: ({ theme: { colors } }) => ({
        color: colors.white,
        marginTop: '0rem',
        paddingTop: '2rem',
        display: 'flex',
        tablet: {
            paddingTop: '2.5rem',
            borderTop: 0,
        },
        tabletLarge: {
            paddingTop: '3rem',
            width: 'max-content',
        },
    }),
};
